import { useEffect, useState } from "react";
import api from "@/lib/api";

export default function About() {
  const [doc, setDoc] = useState(null);
  useEffect(() => { api.get("/legal/about").then(({ data }) => setDoc(data)); }, []);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14">
      <h1 className="font-head text-4xl sm:text-5xl font-black tracking-tighter mb-8">About <span className="text-gradient">SINGVI KARAOKE</span></h1>
      <div className="prose prose-invert max-w-none space-y-5 text-muted-foreground leading-relaxed">
        {doc?.body.split("\n\n").filter(Boolean).map((para, i) => (
          para.startsWith("Why ") ? <h2 key={i} className="font-head text-2xl font-bold text-white pt-4">{para}</h2> : <p key={i}>{para}</p>
        ))}
      </div>
    </div>
  );
}
